import {
    DpSimpleWidgetGroup,
    DpSinclairGeneratedItemsMostProductiveHourWidget,
    DpSinclairGeneratedItemsWidget,
    DpSinclairGenerationErrorsWidget,
    DpSinclairMostProductiveHourWidget,
    DpSinclairTableWidgetsService,
    DpWidgetAppName,
    DpWidgets
} from '@docpath/webcomponents';

import { buildHomeChartWidgetGroups } from './home-chart-widgets';

export function buildHomeWidgets(
    isCloudMode: boolean,
    sinclairTableWidgetsService: DpSinclairTableWidgetsService
): DpWidgets {
    return new DpWidgets({
        appName: DpWidgetAppName.Sinclair,
        chartWidgetGroups: buildHomeChartWidgetGroups(isCloudMode),
        simpleWidgetGroups: [buildSimpleWidgetGroup(isCloudMode)],
        tableWidgetGroups: [sinclairTableWidgetsService.init(isCloudMode)]
    });
}

function buildSimpleWidgetGroup(isCloudMode: boolean): DpSimpleWidgetGroup {
    return new DpSimpleWidgetGroup({
        name: 'home',
        widgets: [
            new DpSinclairGeneratedItemsWidget(isCloudMode),
            new DpSinclairMostProductiveHourWidget(),
            new DpSinclairGeneratedItemsMostProductiveHourWidget(isCloudMode),
            new DpSinclairGenerationErrorsWidget()
        ]
    });
}
